var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoxDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 188,
    viewBox: "0 0 176 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5323,
    cy: 2.86824,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5323,
    cy: 23.0821,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5323,
    cy: 43.295,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5323,
    cy: 63.5089,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5323,
    cy: 83.7227,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5323,
    cy: 103.937,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5323,
    cy: 124.15,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5323,
    cy: 144.364,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5323,
    cy: 164.578,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5323,
    cy: 184.792,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.0069,
    cy: 2.86824,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.0069,
    cy: 23.0811,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.0069,
    cy: 43.296,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.0069,
    cy: 63.5089,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.0069,
    cy: 83.7237,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.0069,
    cy: 103.937,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.0069,
    cy: 124.15,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.0069,
    cy: 144.364,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.0069,
    cy: 164.578,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.0069,
    cy: 184.792,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.4835,
    cy: 2.86824,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.4835,
    cy: 23.0811,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.4835,
    cy: 43.296,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.4835,
    cy: 63.5089,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.4835,
    cy: 83.7237,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.4835,
    cy: 103.937,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.4835,
    cy: 124.15,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.4835,
    cy: 144.364,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.4835,
    cy: 164.578,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.4835,
    cy: 184.792,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9581,
    cy: 2.86824,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9581,
    cy: 23.0811,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9581,
    cy: 43.296,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9581,
    cy: 63.5089,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9581,
    cy: 83.7237,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9581,
    cy: 103.937,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9581,
    cy: 124.15,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9581,
    cy: 144.364,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9581,
    cy: 164.578,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9581,
    cy: 184.792,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.4329,
    cy: 2.86824,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.4329,
    cy: 23.0821,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.4329,
    cy: 43.295,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.4329,
    cy: 63.5089,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.4329,
    cy: 83.7227,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.4329,
    cy: 103.937,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.4329,
    cy: 124.15,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.4329,
    cy: 144.364,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.4329,
    cy: 164.578,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.4329,
    cy: 184.792,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.907,
    cy: 2.86824,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.907,
    cy: 23.0811,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.907,
    cy: 43.296,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.907,
    cy: 63.5089,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.907,
    cy: 83.7237,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.907,
    cy: 103.937,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.907,
    cy: 124.15,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.907,
    cy: 144.364,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.907,
    cy: 164.578,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.907,
    cy: 184.792,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.384,
    cy: 2.86824,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.384,
    cy: 23.0811,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.384,
    cy: 43.296,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.384,
    cy: 63.5089,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.384,
    cy: 83.7237,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.384,
    cy: 103.937,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.384,
    cy: 124.15,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.384,
    cy: 144.364,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.384,
    cy: 164.578,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.384,
    cy: 184.792,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.858,
    cy: 2.86824,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.858,
    cy: 23.0821,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.858,
    cy: 43.295,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.858,
    cy: 63.5089,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.858,
    cy: 83.7227,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.858,
    cy: 103.937,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.858,
    cy: 124.15,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.858,
    cy: 144.364,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.858,
    cy: 164.578,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.858,
    cy: 184.792,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.333,
    cy: 2.86824,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.333,
    cy: 23.0811,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.333,
    cy: 43.296,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.333,
    cy: 63.5089,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.333,
    cy: 83.7237,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.333,
    cy: 103.937,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.333,
    cy: 124.15,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.333,
    cy: 144.364,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.333,
    cy: 164.578,
    r: 2.79207,
    fill: "#EC6B6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.333,
    cy: 184.792,
    r: 2.79207,
    fill: "#EC6B6C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxDots);
export default __webpack_public_path__ + "static/media/box-dots.bc306ece3ec1fda10a6a8be4fce5fdc0.svg";
export { ForwardRef as ReactComponent };